export enum EAccountStatus {
  Active = 'active',
  Blocked = 'blocked',
}

export enum EAccountStatusTitle {
  active = 'Активный',
  blocked = 'Блокирован',
}
